var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.96 5.5h10.08c.9 0 1.64 0 2.22.08.6.08 1.1.25 1.5.65s.58.9.66 1.5c.08.59.08 1.32.08 2.23v7.08c0 .9 0 1.64-.08 2.22-.08.6-.25 1.1-.65 1.5s-.9.58-1.5.66c-.59.08-1.32.08-2.23.08H6.96c-.9 0-1.64 0-2.22-.08-.6-.08-1.1-.25-1.5-.65s-.58-.9-.66-1.5c-.08-.59-.08-1.32-.08-2.23V9.96c0-.9 0-1.64.08-2.22.08-.6.25-1.1.65-1.5s.9-.58 1.5-.66c.59-.08 1.32-.08 2.23-.08M4.87 6.57c-.49.06-.75.18-.93.37-.19.18-.3.44-.37.93-.07.5-.07 1.17-.07 2.13v7c0 .96 0 1.62.07 2.13.06.49.18.75.37.93.18.19.44.3.93.37.5.07 1.17.07 2.13.07h10c.96 0 1.62 0 2.13-.07.49-.06.75-.18.93-.37.19-.18.3-.44.37-.93.07-.5.07-1.17.07-2.13v-7c0-.96 0-1.62-.07-2.13-.06-.49-.18-.75-.37-.93-.18-.19-.44-.3-.93-.37A18 18 0 0 0 17 6.5H7c-.96 0-1.62 0-2.13.07",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.5 11c0-.28.22-.5.5-.5h18a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m6 5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M8 2.5c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5m8 0c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;